export interface DetectedFormat {
  delimiter: string;
  quoteChar: string | null;
  newlineStr: string;
  hasHeader: boolean;
  isEuropeanFormat: boolean;
  warnings?: string[];
}

export interface CSVFile {
  id: string;
  name: string;
  size: number;
  lastModified: number;
  uploadDate: number;
  columns: string[];
  rows: string[][];
  previewData: string[][];
  data?: string[][]; // Optional data property for storing the full CSV data
  fileType: 'csv' | 'xlsx' | 'xls'; // Add fileType property
  detectedFormat?: DetectedFormat; // Add format detection info
}

export interface Location {
  id: number;
  name: string;
  code?: string;
  address?: string;
  organization_id?: number;
}

export interface CSVUploadState {
  files: CSVFile[];
  currentFile: CSVFile | null;
  isUploading: boolean;
  uploadProgress: number;
  error: string | null;
  selectedLocation: Location | null;
  accessibleLocations: Location[];
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
}

export interface ValidationError {
  row: number;
  column: string;
  message: string;
}

export enum UploadStep {
  SELECT_FILE = 'SELECT_FILE',
  VALIDATE_FILE = 'VALIDATE_FILE',
  REVIEW_DATA = 'REVIEW_DATA',
  CONFIRMATION = 'CONFIRMATION'
}

export interface FileUploadProps {
  onFileUploaded: (file: CSVFile) => void;
  maxSize?: number; // in bytes
  allowedFileTypes?: string[];
} 